import React, { useState } from 'react';
import { CheckCircle2, ShieldCheck, Phone, Tag } from 'lucide-react';
const PHONE = '586-203-3701';
export function QuoteForm() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    zip: '',
    service: 'Full Shingle Roof Replacement',
    timeline: 'ASAP — I have damage or a leak',
    notes: ''
  });
  const update = (k: string, v: string) => setForm(f => ({
    ...f,
    [k]: v
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="quote-form" className="bg-[#1a2332] py-20 sm:py-24 relative overflow-hidden" data-id="element-203" data-mp="31v7wr1uxfnxi">
      <div className="absolute inset-0 shingle-pattern opacity-10" data-id="element-204" data-mp="2xvz27us2bm0w" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205" data-mp="3btxi54m17qii">
        <div className="grid lg:grid-cols-5 gap-10 items-start" data-id="element-206" data-mp="3bs4bvqfbz8b1">
          {/* Left column: pitch */}
          <div className="lg:col-span-2 text-white" data-id="element-207" data-mp="3gnqau6rfls7t">
            <div className="inline-flex items-center gap-2 bg-[#2DB8E0]/20 border border-[#2DB8E0]/40 rounded-full px-4 py-1.5 mb-5" data-id="element-208" data-mp="3gp1mesr4c49h">
              <Tag className="w-4 h-4 text-[#2DB8E0]" data-id="element-209" data-mp="3loo176mlhske" />
              <span className="text-[#2DB8E0] font-bold text-xs uppercase tracking-wider" data-id="element-210" data-mp="3ql4pq1xpi8y0">
                $500 Off — Limited Time
              </span>
            </div>
            <h2 className="font-display italic text-4xl sm:text-5xl leading-tight mb-5" data-id="element-211" data-mp="3hq7nxm5f6b5">
              Get Your Free Roof Quote Today
            </h2>
            <p className="text-white/80 leading-relaxed mb-8" data-id="element-212" data-mp="8egncju1jzw1">
              Fill out the form and a Moceri professional will reach out within
              one business day to schedule your free, no-obligation inspection.
              Mention this page to lock in your
              <span className="text-[#2DB8E0] font-bold" data-id="element-213" data-mp="m8r34bo28jpy"> $500 discount</span>.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-214" data-mp="r7uba4zc7625">
              {['Free on-site inspection', 'Upfront, written pricing — no surprises', 'Premium shingles built for Michigan weather', 'Financing available — ask about options'].map(i => <li key={i} className="flex items-start gap-3" data-id="element-215" data-mp="2x1bikzjbgrbz">
                  <CheckCircle2 className="w-5 h-5 text-[#2DB8E0] flex-shrink-0 mt-0.5" data-id="element-216" data-mp="2s8id29g0xeyu" />
                  <span className="text-white/90" data-id="element-217" data-mp="36xobvway9367">{i}</span>
                </li>)}
            </ul>

            <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-3 text-white hover:text-[#2DB8E0] font-bold transition-colors" data-id="element-218" data-mp="31zms195p8zto">
              <Phone className="w-5 h-5 text-[#2DB8E0]" data-id="element-219" data-mp="3az9u7x6969ns" />
              Prefer to call? {PHONE}
            </a>
          </div>

          {/* Right column: form card */}
          <div className="lg:col-span-3" data-id="element-220" data-mp="1glidyetf4rjd">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 relative overflow-hidden" data-id="element-221" data-mp="1gmk0pgjsr2gx">
              <div className="absolute top-0 left-0 w-full h-2 bg-[#2DB8E0]" data-id="element-222" data-mp="3s9vm3reo3m67" />

              {submitted ? <div className="text-center py-10" data-id="element-223" data-mp="1182bfw2s70r">
                  <div className="w-16 h-16 bg-[#2DB8E0]/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-224" data-mp="3jgsa7njo7hdo">
                    <CheckCircle2 className="w-9 h-9 text-[#2DB8E0]" data-id="element-225" data-mp="3nhc6yq0c0iza" />
                  </div>
                  <h3 className="font-display italic text-3xl text-[#1a2332] mb-3" data-id="element-226" data-mp="39i33mqx85jcq">
                    Thanks, {form.name.split(' ')[0] || 'friend'}!
                  </h3>
                  <p className="text-slate-600 mb-6 max-w-md mx-auto" data-id="element-227" data-mp="30ho6muawefte">
                    We've received your request and a Moceri team member will
                    reach out within one business day. Need it sooner?
                  </p>
                  <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-2 bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-6 py-3 rounded-full transition-colors" data-id="element-228" data-mp="yrcmj1fr08s9">
                    <Phone className="w-5 h-5" data-id="element-229" data-mp="925v5x8rs1vp" /> Call {PHONE}
                  </a>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-230" data-mp="429rjz3zicgo">
                  <h3 className="font-display italic text-3xl text-[#1a2332] mb-1" data-id="element-231" data-mp="3v9dx0pkhdqmz">
                    Claim Your $500 Off
                  </h3>
                  <p className="text-sm text-slate-500 mb-4" data-id="element-232" data-mp="3r8kbg2uignx9">
                    No spam. No obligation. Response within 1 business day.
                  </p>

                  <div data-id="element-233" data-mp="3hhpm2plyx87l">
                    <label htmlFor="name" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-234" data-mp="3hj0q8qjbshz8">
                      Full Name <span className="text-[#2DB8E0]" data-id="element-235" data-mp="37kb76ufp0rhe">*</span>
                    </label>
                    <input id="name" type="text" required value={form.name} onChange={e => update('name', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="John Smith" data-id="element-236" data-mp="33ig8lxp5cs7b" />
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4" data-id="element-237" data-mp="zcg5ul5vc87h">
                    <div data-id="element-238" data-mp="zdzi80oelz3z">
                      <label htmlFor="phone" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-239" data-mp="14b997krfyitx">
                        Phone <span className="text-[#2DB8E0]" data-id="element-240" data-mp="198j59j9c5sqq">*</span>
                      </label>
                      <input id="phone" type="tel" required value={form.phone} onChange={e => update('phone', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="(586) 555-0100" data-id="element-241" data-mp="1e35f3hzrrd8p" />
                    </div>
                    <div data-id="element-242" data-mp="ib279fs8vdy6">
                      <label htmlFor="zip" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-243" data-mp="ibtrjuge5p95">
                        ZIP Code <span className="text-[#2DB8E0]" data-id="element-244" data-mp="3mpik9r6ygybh">*</span>
                      </label>
                      <input id="zip" type="text" required value={form.zip} onChange={e => update('zip', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="48081" data-id="element-245" data-mp="4jx443po43j3" />
                    </div>
                  </div>

                  <div data-id="element-246" data-mp="2xwyyfoffo5iv">
                    <label htmlFor="email" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-247" data-mp="2xu2xrsc7b2qq">
                      Email <span className="text-[#2DB8E0]" data-id="element-248" data-mp="2ow0zhkjuqo75">*</span>
                    </label>
                    <input id="email" type="email" required value={form.email} onChange={e => update('email', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="john@example.com" data-id="element-249" data-mp="3cmd3ikbz80sg" />
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4" data-id="element-250" data-mp="46te5weff2io">
                    <div data-id="element-251" data-mp="208wr0xlbae68">
                      <label htmlFor="service" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-252" data-mp="2096loyhax9i9">
                        Service Needed
                      </label>
                      <select id="service" value={form.service} onChange={e => update('service', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all bg-white" data-id="element-253" data-mp="1ljigvn9wvsps">
                        <option data-id="element-254" data-mp="257hud5vv1dyw">Full Shingle Roof Replacement</option>
                        <option data-id="element-255" data-mp="25785jlmjxcus">Asphalt Shingle Roof</option>
                        <option data-id="element-256" data-mp="xu6bkyhpg4sr">Storm/Hail Damage Inspection</option>
                        <option data-id="element-257" data-mp="tscgd5qa3szz">Not sure — need advice</option>
                      </select>
                    </div>
                    <div data-id="element-258" data-mp="35g7s9lov89ew">
                      <label htmlFor="timeline" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-259" data-mp="35gzdc2ku6oqx">
                        Timeline
                      </label>
                      <select id="timeline" value={form.timeline} onChange={e => update('timeline', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all bg-white" data-id="element-260" data-mp="3j72uwg8rtua1">
                        <option data-id="element-261" data-mp="zn36523qjq8">ASAP — I have damage or a leak</option>
                        <option data-id="element-262" data-mp="5zrpibpoy8od">Within 1 month</option>
                        <option data-id="element-263" data-mp="22tcnazig0nvn">1–3 months</option>
                        <option data-id="element-264" data-mp="22unvdbix8hsk">Just getting quotes</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-265" data-mp="3ou1ugvn53mgu">
                    <label htmlFor="notes" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-266" data-mp="3ouv17wm3mbyz">
                      Tell us about your project{' '}
                      <span className="text-slate-400 font-normal" data-id="element-267" data-mp="2la9m4ye18k3">
                        (optional)
                      </span>
                    </label>
                    <textarea id="notes" rows={3} value={form.notes} onChange={e => update('notes', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all resize-none" placeholder="e.g. Two-story colonial, missing shingles after last storm…" data-id="element-268" data-mp="bo1q4j64euil" />
                  </div>

                  <button type="submit" className="w-full bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold text-lg py-4 rounded-full transition-all shadow-md hover:shadow-lg mt-2" data-id="element-269" data-mp="zddtv3ioiadi">
                    Get My Free Quote + $500 Off
                  </button>

                  <p className="text-xs text-center text-slate-500 flex items-center justify-center gap-1.5" data-id="element-270" data-mp="2awb4q6rsdhw2">
                    <ShieldCheck className="w-3.5 h-3.5" data-id="element-271" data-mp="25xgisvyivd7q" /> Your information is
                    secure and private.
                  </p>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}